import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    position: ", ";\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n\n    transition: ", ";\n    transition-property: opacity, z-index;\n    will-change: opacity, z-index;\n    z-index: ", ";\n    opacity: ", ";\n\n    ", " {\n        opacity: ", ";\n    }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    left: 46%;\n    top: 45%;\n    transform: translate(-50%, -50%);\n    font-size: 40px;\n\n    color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 100%;\n    background-color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { Icon } from '../Icon';
export var StyledBackdrop = styled.div(_templateObject(), function (props) {
  return props.theme.components.modal.backgroundColor;
});
export var StyledIcon = styled(Icon)(_templateObject2(), function (props) {
  return props.theme.components.loading.color;
});
export var StyledLoading = styled.div(_templateObject3(), function (props) {
  return props.fixed ? 'fixed' : 'absolute';
}, function (props) {
  return props.theme.components.modal.transition;
}, function (props) {
  return props.visible ? props.theme.components.loading.zIndex : -1;
}, function (props) {
  return props.visible ? 0.8 : 0;
}, StyledIcon, function (props) {
  return props.visible ? 1 : 0;
});